<template>
    <el-dialog
        :title="expend && expend.id ? '修改支出单' : '新增支出单'"
        :visible.sync="showDialog"
        width="500px"
        @closed="refeshRule"
    >
        <el-form ref="addForm" :model="expend" label-width="80px" :rules="rules">
            <el-form-item label="支出类型" prop="typeId">
                <el-select v-model="expend.typeId" placeholder="请选择支出类型">
                    <el-option
                        v-for="item in types"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="是否报销" prop="needAccount">
                <el-select v-model="expend.needAccount" placeholder="请选择是否报销">
                    <el-option
                        v-for="item in valids"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="支出日期" prop="expendTime">
                <el-date-picker
                    type="date"
                    placeholder="选择计划开始日期"
                    v-model="expend.expendTime"
                    style="width: 100%"
                ></el-date-picker>
            </el-form-item>

            <el-form-item label="支出金额" prop="cost_2" v-if="!billIds">
                <el-input-number v-model="expend.cost_2" :min="0" :precision="2" :controls="false"></el-input-number>
            </el-form-item>

            <el-form-item label="备注" prop="remark">
                <el-input v-model="expend.remark" type="textarea"></el-input>
            </el-form-item>
        </el-form>

        <sn-file-upload relateType="FinanceExpense" :relateId="expend.id" :files.sync="expend.files"></sn-file-upload>

        <div slot="footer" class="dialog-footer">
            <el-button type="primary" size="small" class="op-button" @click="postAdd">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
import SnFileUpload from '../components/SnFileUpload.vue';
export default {
    components: { SnFileUpload },
    props: {
        show: { type: Boolean, default: false },
        expendId: { type: String, default: null },
        billIds: { type: String, default: null },
        afterAdd: { type: Function, default: null },
    },
    data() {
        return {
            showDialog: false,
            records: null,
            shops: null,
            types: null,
            expend: {},
            rules: {
                needAccount: [
                    { required: true, message: "请选择是否需要报销", trigger: "blur" },
                ],

                typeId: [
                    {
                        required: true,
                        message: "请选择支出类型",
                        trigger: "blur",
                    },
                ],

                expendTime: [
                    {
                        required: true,
                        message: "请输入支出时间",
                        trigger: "blur",
                    },
                ],

                cost_2: [
                    {
                        required: true,
                        message: "请输入支出金额",
                        trigger: "blur",
                    },
                ],
                remark: [
                    {
                        min: 0,
                        max: 64,
                        message: "长度在 0 到 64 个字符",
                        trigger: "blur",
                    },
                ],
            },
            valids: [
                { id: "Y", name: "是" },
                { id: "N", name: "否" }
            ],
        };
    },
    methods: {
        getType() {
            let _this = this;

            _this.$http.post(
                ["finance/expense/type/all"],
                [
                    function (data) {
                        _this.types = data;

                        if (_this.expendId) {
                            _this.getExpend();
                        } else {
                            _this.expend = {};
                        }
                    },
                ],
                "none"
            );
        },
        postAdd() {
            this.$refs["addForm"].validate().then(this.doAdd);
        },
        doAdd() {
            let _this = this;

            _this.expend.cost = _this.expend.cost_2 * 100;

            if (_this.billIds) {
                _this.expend.bills = _this.billIds;
            }

            _this.$http.post(
                ["finance/expense/save", _this.expend],
                [
                    function (data) {
                        _this.showDialog = false;
                        _this.expend = {};
                        _this.$emit("afterAdd", data);
                    },
                ],
                ".op-button"
            );
        },
        refeshRule() {
            this.expend = {};
            this.$refs["addForm"].resetFields();
            this.$emit("update:show", false);
        },
        getExpend() {
            let _this = this;

            _this.$http.post(
                ["finance/expense/get", {id: _this.expendId}],
                [
                    function (data) {
                        _this.expend = data;
                        _this.expend.cost_2 = _this.expend.cost / 100;
                        _this.showDialog = true;
                    },
                ],
                "none"
            );
        }
    },
    mounted() {},
    watch: {
        show(val) {
            if (val) {
                this.getType();
            }

            this.showDialog = val;
        },
    },
};
</script>

<style lang="scss">
</style>